<div [ngClass]="{'w-100 partial-height-mobile': !viewportService.isLargeViewPort(), 'h-100 width-400px': viewportService.isLargeViewPort()}"
     class="position-absolute overflow-x-hidden background-white z-max">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row position-fixed background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()" class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2" type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-gateway-svg [status]="status()"
                             [online]=true
                             class="img-fluid img-max m-0"></app-gateway-svg>
        </div>
        <div class="col-8 m-0">
            <div class="row m-auto">
                <div class="fw-bold">{{ gateway()?.name }}</div>
                <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
            </div>
        </div>
        <div (click)="close()" class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2" type="button">
            <i class="fa-solid fa-x color-secondary-information"></i>
        </div>
    </div>
    <div class="flex-grow-1 d-flex flex-column margin-top-details-header ps-3 pe-3 pb-3 gap-3">
        <app-generic-button
            (click)="toggleCustomize('/main/customize-gateway')"
            description="Customize gateway"
            [alwaysShowText]="true"
            [buttonText]="'Customize'"
            [disabled]="!canBeAltered"
            [primaryIcon]="'fa-solid fa-gear'"/>
        <app-generic-button
            (click)="delete()"
            description="Delete gateway"
            [alwaysShowText]="true"
            [buttonClass]="'btn-danger btn-danger-shadow'"
            [buttonText]="'Delete'"
            [disabled]="!canBeDeleted"
            [primaryIcon]="'fa-solid fa-trash-can'"/>
        <div>
            <div class="row">
                <div class="col fw-bold">LoRa Gateway ID</div>
            </div>
            <div class="row">
                <div class="col ">{{ id() || '?' }}</div>
            </div>
        </div>
    </div>
</div>
